import { IPageState } from '../../types/page';

const defaultState: IPageState = {
  type: 'other',
};

export function pageReducer(state: IPageState = defaultState): IPageState {
  return state;
}
